var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { TicketLine } from '../modules/Reports/Model';
export var optionsTree = function (items, subKey, itemRender, exclude, level) {
    if (level === void 0) { level = 0; }
    return items.reduce(function (prev, item) {
        if (exclude && exclude(item, level))
            return prev;
        prev.push(itemRender(item, '-'.repeat(level * 2)));
        var subTree = item[subKey] || [];
        if (subTree.length > 0)
            return prev.concat(optionsTree(subTree, subKey, itemRender, exclude, level + 1));
        return prev;
    }, []);
};
export var countSubTrees = function (parent, subKey) {
    return (parent[subKey] || []).reduce(function (prev, item) {
        if (item[subKey])
            return prev + countSubTrees(item, subKey);
        return prev;
    }, 1);
};
export var timeQuery = function (url, date) {
    return url && "".concat(url, "?t=").concat(date.getTime());
};
import natsort from 'natsort';
import { VoucherLine } from '../modules/Vouchers/Model';
import moment from 'moment';
export var narutalSort = function (array, // tslint:disable-line:no-any
key, desc) {
    if (desc === void 0) { desc = false; }
    return array.sort(function (a, b) {
        if (key && typeof a[key] === 'string' && typeof b[key] === 'string') {
            var resultA = moment(a[key], 'DD/MM/YYYY HH:mm:ss', true);
            var resultB = moment(b[key], 'DD/MM/YYYY HH:mm:ss', true);
            if (resultA.isValid() && resultB.isValid()) {
                return desc ? resultA.valueOf() - resultB.valueOf() : resultB.valueOf() - resultA.valueOf();
            }
        }
        return natsort({ desc: desc })(key && a[key], key && b[key]);
    });
};
export var objectValues = function (object) {
    var keys = Object.keys(object);
    var values = []; // tslint:disable-line:no-any
    for (var i = 0, length = keys.length; i < length; i++) {
        values.push(object[keys[i]]);
    }
    return values;
};
export var mapValues = function (object, iteratee) {
    var keys = Object.keys(object);
    for (var i = 0, length = keys.length; i < length; i++) {
        object[keys[i]] = iteratee(object[keys[i]]);
    }
    return object;
};
var isObject = function (item) {
    return item && typeof item === 'object' && !Array.isArray(item);
};
export var mergeDeep = function (target) {
    var _a, _b;
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    if (!sources.length)
        return target;
    var source = sources.shift();
    if (isObject(target) && isObject(source)) {
        for (var key in source) {
            if (isObject(source[key])) {
                if (!target[key])
                    Object.assign(target, (_a = {}, _a[key] = {}, _a));
                mergeDeep(target[key], source[key]);
            }
            else {
                Object.assign(target, (_b = {}, _b[key] = source[key], _b));
            }
        }
    }
    return mergeDeep.apply(void 0, __spreadArray([target], sources, false));
};
export var twoDigits = function (value) {
    if (value > 9) {
        return String(value);
    }
    return "0".concat(value);
};
export var getQuantityFromLines = function (lines) {
    if (!lines) {
        return 0;
    }
    var result = lines.reduce(function (previousValue, currentValue) {
        if (currentValue instanceof TicketLine) {
            previousValue = previousValue + currentValue.quantity;
        }
        else if (currentValue instanceof VoucherLine) {
            previousValue++; // cada line es un pasajero
        }
        return previousValue;
    }, 0);
    return result;
};
export var copyToClipboard = function (data, type) { return __awaiter(void 0, void 0, void 0, function () {
    var clipboardItem, _data_1;
    return __generator(this, function (_a) {
        if ('clipboard' in navigator) {
            if (!type) {
                return [2 /*return*/, navigator.clipboard.writeText(data)];
            }
            clipboardItem = new window.ClipboardItem({
                'text/html': new Blob([data], { type: 'text/html' })
            });
            _data_1 = [clipboardItem];
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    try {
                        // @ts-ignore
                        navigator.clipboard.write(_data_1);
                        return resolve(true);
                    }
                    catch (e) {
                        return reject(false);
                    }
                })];
        }
        else {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    try {
                        document.execCommand('copy', true, data);
                        return resolve(true);
                    }
                    catch (e) {
                        return reject(false);
                    }
                })];
        }
        return [2 /*return*/];
    });
}); };



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Utils.ts
// module id = 33
// module chunks = 0